import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { environment } from '../../../environments/environment';
import { AuthState } from './auth/auth.state';
import { DeliveriesState } from './deliveries/deliveries.state';
import { OcaDeliveriesState } from './ocaDeliveries/ocaDeliveries.state';
import { ReturnsState } from './returns/returns.state';
import { UserState } from './users/user.state';
import { DashboardState } from './dashboard/dashboard.state';
import { RoleState } from './roles/role.state';
import { MotivoNoEntregaState } from './configuracion/motivo-no-entrega.state';
import { NotificationState } from './notification/notification.state';
import { SerpaqDeliveriesState } from './serpaqDeliveries/serpaqDeliveries.state';
import { AtencionClienteDashboardState } from './atencion-cliente-dashboard/atencion-cliente-dashboard.state';

export const ngxsProviders: EnvironmentProviders = importProvidersFrom(
  NgxsModule.forRoot(
    [AuthState, DeliveriesState, OcaDeliveriesState, ReturnsState, UserState, DashboardState, RoleState, MotivoNoEntregaState, NotificationState, SerpaqDeliveriesState, AtencionClienteDashboardState],
    {
      developmentMode: !environment.production,
    }
  ),
  NgxsStoragePluginModule.forRoot({
    keys: ['auth.token', 'auth.user', 'auth.credentials'],
  }),
  NgxsLoggerPluginModule.forRoot(),
  NgxsReduxDevtoolsPluginModule.forRoot()
);
